import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { FULL_ROLE } from '@utils/helpers'

const feedbackRoutes = {
  path: 'feedback',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.feedback'),
  },
  children: [
    {
      path: '',
      name: 'feedback',
      component: () => lazyLoadView(import('@views/Feedback/feedback.vue')),
      meta: {
        authRequired: FULL_ROLE,
      },
    },
  ],
}

export default feedbackRoutes
